module.exports = __webpack_public_path__ + "img/oldFourFalse.95986a34.png";